import { PreloadingStrategy, Route } from '@angular/router';
import { concatMap, Observable, of, timer } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { Nullable } from '@shared/models/types';
import { LoggerService } from '@core/log/services/logger';

@Injectable({ providedIn: 'any' })
export class CustomPreloadingStrategy implements PreloadingStrategy {
  private readonly logger = inject(LoggerService);
  private readonly loadedModules = new Set<string>();
  private baseTime = 0;

  public preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    let result: Observable<unknown> = of(null);
    if (route.data != null && route.data['preload']) {
      const delay = Number(route.data['delay'] ?? 0);
      result = timer(delay + this.baseTime).pipe(
        concatMap(() => {
          const moduleName = route.data?.['moduleName'] as Nullable<string>;
          if (moduleName && !this.loadedModules.has(moduleName)) {
            this.loadedModules.add(moduleName);
            this.logger.log(`Loading now ${route.data?.['moduleName'] ?? 'lazy'} module/component`);
          }
          return load();
        })
      );
      this.baseTime += 500;
    }
    return result;
  }
}
